import { USCityView } from '@zola/svc-marketplace-ts-types';

import { LocationOrAllMarketsType } from '~/types/responseTypes';

type PartialUSCityView = Partial<USCityView> & { name: string; slug: string };

export const TOP_CITIES: PartialUSCityView[] = [
  {
    slug: 'atlanta-ga',
    name: 'Atlanta',
  },
  {
    slug: 'austin-tx',
    name: 'Austin',
  },
  {
    slug: 'boston-ma',
    name: 'Boston',
  },
  {
    slug: 'charlotte-nc',
    name: 'Charlotte',
  },
  {
    slug: 'chicago-il',
    name: 'Chicago',
  },
  {
    slug: 'cleveland-il',
    name: 'Cleveland',
  },
  {
    slug: 'dallas-tx',
    name: 'Dallas',
  },
  {
    slug: 'denver-co',
    name: 'Denver',
  },
  {
    slug: 'detroit-mi',
    name: 'Detroit',
  },
  {
    slug: 'houston-tx',
    name: 'Houston',
  },
  {
    slug: 'los-angeles-ca',
    name: 'Los Angeles',
  },
  {
    slug: 'nashville-tn',
    name: 'Nashville',
  },
  {
    slug: 'new-york-ny',
    name: 'New York City',
  },
  {
    slug: 'orlando-fl',
    name: 'Orlando',
  },
  {
    slug: 'philadelphia-pa',
    name: 'Philadelphia',
  },
  {
    slug: 'phoenix-az',
    name: 'Phoenix',
  },
  {
    slug: 'pittsburgh-pa',
    name: 'Pittsburgh',
  },
  {
    slug: 'san-diego-ca',
    name: 'San Diego',
  },
  {
    slug: 'seattle-wa',
    name: 'Seattle',
  },
  {
    slug: 'washington-dc',
    name: 'Washington, DC',
  },
];

export const NYC_BOROUGHS: PartialUSCityView[] = [
  {
    slug: 'bronx-ny',
    name: 'Bronx, NY',
  },
  {
    slug: 'brooklyn-ny',
    name: 'Brooklyn, NY',
  },
  {
    slug: 'manhattan-ny',
    name: 'Manhattan, NY',
  },
  {
    slug: 'queens-ny',
    name: 'Queens, NY',
  },
  {
    slug: 'staten-island-ny',
    name: 'Staten Island, NY',
  },
];

/**
 * Determine whether a specified location is a NYC borough
 */
export const isBorough = (location: LocationOrAllMarketsType | Partial<USCityView>) => {
  return Boolean(NYC_BOROUGHS.find((borough) => borough.slug === location.slug));
};
